import { defineEffect } from '../../../core/effect';
import { chainSolvingSpec } from '../fx/chainSolving';

/** チェーンの処理（札が抜け出て拡大）（Issue #589。状況は共通側の `editorPorts/duelSituations/chain_solving.js` が決め、絵の組み立ては `../fx/chainSolving.js`） */
export default defineEffect({ situation: 'chain_solving_zoom', role: 'effect', ...chainSolvingSpec('zoom') }, 'chain_solving_zoom_effect.js');
